module.exports = __webpack_public_path__ + "static/img/d-rulebg-kiko.39ff6890.webp";